import React from 'react';
import './LocationAddress.less';

export const LocationAddress = ({text}) => {
	return <span className="location-address">{text}</span>
}
